angular.module('app.controllers.contact', []).controller('ContactController', ['$rootScope', '$scope', '$log', '$modal','$window', function ($rootScope, $scope, $log, $modal,$window) {

  'use strict';

  $log.debug('ContactController()');

  $scope.open = function (type) {

    var modalInstance = $modal.open({
      animation: true,
      templateUrl: 'templates/contact/'+type+'.html',
      controller: 'ContactModalController',
      size: 'lg',
      resolve: {
      }
    });
  };
   
  $scope.openWindow = function(type) {
        //$window.alert("Hello");
        $window.open(type, '_blank');
    };  

}]);

angular.module('app.controllers.contact').controller('ContactModalController', function ($scope, $modalInstance) {

  $scope.ok = function () {
    $modalInstance.close();
  };

});



